/**
 * 应用组合。
 *
 * 顺序有讲究：主题 → 提示条 → 数据 → 外壳。
 * 提示条要在数据之外，否则页面切换会把它一起卸载掉。
 */

import { AppShell } from './components/AppShell';
import { ToastProvider } from './components/Toast';
import { AppDataProvider } from './state/app-context';

export function App(): JSX.Element {
	return (
		<ToastProvider>
			<AppDataProvider>
				<AppShell />
			</AppDataProvider>
		</ToastProvider>
	);
}
